import { create } from 'zustand'

import { PostModel } from '@/common/models/post'

interface ViewNewsStore {
  news: PostModel | null
  setNews: (news: PostModel | null) => void
}

export const useViewNewsStore = create<ViewNewsStore>((set) => ({
  news: null,
  setNews: (news) => set({ news }),
}))
